import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Helmet } from "react-helmet-async";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export default function SalesChart({ salesData }) {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        labels: {
          color: "#1c1917",
          font: { family: "Source Sans", size: 14 },
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: "Sales & Orders Overview",
        color: "#1c1917",
        font: { family: "Playfair Display", size: 18, weight: "bold" },
        padding: { bottom: 20 },
      },
      tooltip: {
        backgroundColor: "#1c1917",
        titleFont: { family: "Playfair Display", size: 14 },
        bodyFont: { family: "Source Sans", size: 13 },
        padding: 12,
        cornerRadius: 6,
      },
    },
    scales: {
      x: {
        ticks: { color: "#57534e", font: { family: "Source Sans", size: 12 } },
        grid: { color: "#e7e5e4" },
      },
      y: {
        ticks: { color: "#57534e" },
        grid: { color: "#e7e5e4" },
      },
      y1: {
        position: "right",
        ticks: { color: "#3fbcb1" },
        grid: { color: "#3fbcb1"  },// grid: { drawOnChartArea: false },
      },
    },
    elements: {
      line: { tension: 0.4 }, // smooth curves
      point: { radius: 4, hoverRadius: 6 },
    },
  };

  const labels = salesData?.map((data) => data?.date);

  const data = {
    labels,
    datasets: [
      {
        label: "Sales ($)",
        data: salesData?.map((data) => data?.sales),
        borderColor: "#BC3F4A", // Sanguine red accent
        backgroundColor: "#BC3F4A",
        yAxisID: "y",
        fill: true,
      },
      {
        label: "Orders",
        data: salesData?.map((data) => data?.numOrders),
        borderColor: "#3fbcb1",  // complementary to sanguine red accent
        backgroundColor: "#3fbcb1",
        yAxisID: "y1",
        fill: true,
      },
    ],
  };

  return (
    <>
     <Helmet>
        <title>Sales Chart</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    <div className="bg-[#f5f3ea] p-6 rounded-lg shadow-md border border-[#e2e1d8]">
      <div className="h-96">
        <Line options={options} data={data} />
      </div>
    </div>
    </>
  );
}
